import Laravel from '@/services/Laravel'

export default {
  async getChart(chartSlug) {
    try {
      let chartResponse = Laravel.get(`admin-charts/${chartSlug}`, {
        timeout: 15000,
      })
      return chartResponse
    } catch (err) {
      return Promise.reject(err)
    }
  }, // login
}
